const COLS = 'ABCDEFGHJKLMNOPQRST'; // skip I

export function sgfToColRow(sgf: string): [number, number] {
  return [sgf.charCodeAt(0) - 97, sgf.charCodeAt(1) - 97];
}

export function sgfToAlpha(sgf: string): string {
  const [col, row] = sgfToColRow(sgf);
  return `${COLS[col]}${19 - row}`;
}

export function alphaToSgf(alpha: string): string {
  const col = COLS.indexOf(alpha[0]);
  const row = 19 - parseInt(alpha.slice(1));
  return String.fromCharCode(97 + col) + String.fromCharCode(97 + row);
}

export function getBoundingBox(coords: string[], padding = 2) {
  if (coords.length === 0) return { minCol: 0, maxCol: 18, minRow: 0, maxRow: 18 };

  const cols = coords.map(c => c.charCodeAt(0) - 97);
  const rows = coords.map(c => c.charCodeAt(1) - 97);

  return {
    minCol: Math.max(0, Math.min(...cols) - padding),
    maxCol: Math.min(18, Math.max(...cols) + padding),
    minRow: Math.max(0, Math.min(...rows) - padding),
    maxRow: Math.min(18, Math.max(...rows) + padding),
  };
}
